/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GivenProfileViewsRequest
 */
export interface GivenProfileViewsRequest {
    /**
     * 
     * @type {string}
     * @memberof GivenProfileViewsRequest
     */
    identityId: string;
    /**
     * 
     * @type {number}
     * @memberof GivenProfileViewsRequest
     */
    profileViews: number;
}

/**
 * Check if a given object implements the GivenProfileViewsRequest interface.
 */
export function instanceOfGivenProfileViewsRequest(value: object): value is GivenProfileViewsRequest {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('profileViews' in value) || value['profileViews'] === undefined) return false;
    return true;
}

export function GivenProfileViewsRequestFromJSON(json: any): GivenProfileViewsRequest {
    return GivenProfileViewsRequestFromJSONTyped(json, false);
}

export function GivenProfileViewsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GivenProfileViewsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'profileViews': json['profileViews'],
    };
}

export function GivenProfileViewsRequestToJSON(value?: GivenProfileViewsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'profileViews': value['profileViews'],
    };
}

